export class LoadAccountsCitiesNamingsFromApi {
    public static readonly type: string = '[Accounts API] Load city Mappings';
}
